import { useTheme } from '@mui/material';

export const MapPinIcon = ({ color }: {color?: string;}) => {
  const theme = useTheme();

  return (
    <svg id="mappinicon__assets-icons-v2__svg__l7"
    xmlns="http://www.w3.org/2000/svg"
    className="icon icon-tabler icon-tabler-map-pin"
    width={18}
    height={18}
    viewBox="0 0 24 24"
    strokeWidth={1}
    stroke={color ?? theme.palette.common.black}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round">
      
      <path id="mappinicon__assets-icons-v2__path__l19" stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path id="mappinicon__assets-icons-v2__path__l20" d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
      <path id="mappinicon__assets-icons-v2__path__l21" d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z" />
    </svg>);

};